import React from 'react';
import { Row, Col, Card } from 'antd';
import { Link } from 'react-router-dom';
import { constants } from '../../../devUtils';
import { AppWrappperHOC } from '../../Root/HOC';
import StyledThankYou from './StyledThankyou';
import endPoints from '../../../config/endPoints';
import THANKYOU_CONSTANTS from './constants';
import LandingContainer from '../../../components/LandingContainer';

function Thankyou() {
  const { SOCIAL_MEDIA } = THANKYOU_CONSTANTS;
  return (
    <StyledThankYou>
      <Row type="flex" align="top" gutter={24} className="banner-thank-u">
        <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
          <LandingContainer>
            <h1 className="text-red nomargin-bottom">Thank You!</h1>
            <p className="font-18">Thank you for connecting with us. We will get in touch with you shortly!</p>
            <Row type="flex" align="middle">
              <Col xs={24} sm={24} md={5} lg={5} xl={5} />
              <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                <Card className="card-padding-20 card-bg">
                  <img src={endPoints.THANKYOU_CALL} alt="" className="width-2" />
                  <p className="font-14 margin-t-1 nomargin-bottom">Contact Number</p>
                  <Link to={constants.ZAGGLE_TOLL_FREE_NUM} className="font-18"><b>1860 500 1231</b></Link>
                </Card>
              </Col>
              <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                <Card className="card-padding-20 card-bg">
                  <img src={endPoints.THANKYOU_EMAIL} alt="" className="width-2" />
                  <p className="font-14 margin-t-1 nomargin-bottom">Email Id</p>
                  <Link to={constants.ZAGGLE_EMAIL_ID} className="font-18"><b>team@zaggle.in</b></Link>
                </Card>
              </Col>
              <Col xs={24} sm={24} md={5} lg={5} xl={5} />
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center padding-t-5">
                <p className="nomargin-bottom font-16">Connect us</p>
                <ul className="social-media">
                  {SOCIAL_MEDIA.map((item) => (
                    <li key={item.keyIndex}>
                      <a href={item.href} target="_blank">
                        <i className={item.className}></i>
                      </a>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          </LandingContainer>
        </Col>
      </Row>
    </StyledThankYou>
  );
}

const component = AppWrappperHOC(Thankyou);

export { Thankyou };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/Thankyou/index.js